import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * ScrollToTopButton
 * Floating button that appears once the user has scrolled > 400px. Clicking
 * smoothly scrolls the page to the top. Positioned above the WhatsApp FAB.
 */
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    catch { window.scrollTo(0, 0); }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll to top"
      data-testid="scroll-to-top-btn"
      className={`fixed right-6 bottom-28 z-50 w-12 h-12 rounded-full bg-[#023E8A] text-white shadow-xl hover:bg-[#00B4D8] transition-all duration-300 flex items-center justify-center ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <ChevronUp className="w-5 h-5" />
    </button>
  );
};

export default ScrollToTopButton;
